import React, { FC } from 'react'

import { useTranslation } from '@Globals/Translations'

import styles from './SideCartEmpty.module.scss'

export interface SideCartEmptyProps {
}

export const SideCartEmpty: FC<SideCartEmptyProps> = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.sideCartEmpty}>
      <h1 className={styles.title}>{t('cart:HALF_EMPTY_OR_HALF_FULL')}</h1>
      <p className={styles.text}>{t('cart:NOT_SURE_WE_CAN_SPIN_EMPTY_CART_TEXT')}</p>
    </div>
  )
}

